export default __webpack_public_path__ + "static/media/dagpacketd.e45201b0.png";